<ng-container [ngSwitch]="accessType">
  <div class="simple-permission-label" *ngSwitchCase="'private'">
    <i class="fs-16px sp-mr-5" ui-icon uiType="restricted"></i>
    <span class="fs-14px text-container">{{ "private_access_only_you" | localize }}</span>
  </div>
  <div class="simple-permission-label" *ngSwitchCase="'restricted'">
    <i class="fs-16px sp-mr-5" ui-icon uiType="users-group"></i>
    <span class="fs-14px text-container">{{ "private_access_only_invited" | localize }}</span>
  </div>
  <div class="simple-permission-label" *ngSwitchCase="'publicRead'">
    <i class="fs-16px sp-mr-5" ui-icon uiType="view-only"></i>
    <span class="fs-14px text-container">{{ "everyone_can_view" | localize }}</span>
  </div>
  <div class="simple-permission-label" *ngSwitchCase="'publicUpdate'">
    <i class="fs-16px sp-mr-5" ui-icon uiType="inline"></i>
    <span class="fs-14px text-container">{{ "everyone_can_edit" | localize }}</span>
  </div>
</ng-container>
